import { useState, useEffect, useCallback } from "react";
import { dataverseClient } from "../services/dataverseClient";

export function useCrmLookup(senderEmail: string | undefined) {
  const [contacts, setContacts] = useState<any[]>([]);
  const [leads, setLeads] = useState<any[]>([]);
  const [opportunities, setOpportunities] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const lookup = useCallback(async () => {
    if (!senderEmail) return;

    setLoading(true);
    setError(null);

    try {
      const [contactResults, leadResults] = await Promise.all([
        dataverseClient.findContactByEmail(senderEmail),
        dataverseClient.findLeadByEmail(senderEmail),
      ]);

      setContacts(contactResults);
      setLeads(leadResults);

      if (contactResults.length > 0) {
        const contact = contactResults[0];
        // _parentcustomerid_value is polymorphic — check the annotation to
        // confirm it points to an account (not another contact)
        const lookupType =
          contact["_parentcustomerid_value@Microsoft.Dynamics.CRM.lookuplogicalname"];
        const accountId =
          lookupType === "account" ? contact._parentcustomerid_value : undefined;
        const oppResults = await dataverseClient.getOpportunitiesForContact(
          contact.contactid,
          accountId
        );
        setOpportunities(oppResults);
      } else {
        setOpportunities([]);
      }
    } catch (err) {
      setError(err instanceof Error ? err : new Error("CRM lookup failed"));
    } finally {
      setLoading(false);
    }
  }, [senderEmail]);

  useEffect(() => {
    lookup();
  }, [lookup]);

  return { contacts, leads, opportunities, loading, error, refresh: lookup };
}
